import { render, staticRenderFns } from "./campaignTeams.vue?vue&type=template&id=6fc6a260&scoped=true&"
import script from "./campaignTeams.vue?vue&type=script&lang=js&"
export * from "./campaignTeams.vue?vue&type=script&lang=js&"
import style0 from "./campaignTeams.vue?vue&type=style&index=0&id=6fc6a260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6a260",
  null
  
)

export default component.exports